// extracted by mini-css-extract-plugin
export default {"mainContainer":"Header_mainContainer__81StX","endContainer":"Header_endContainer__DRuN1","burger":"Header_burger__b3b+1","envSwitch":"Header_envSwitch__3sTTe"};